/*eslint-disable*/
import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { useHistory } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import axios from "axios";
import { headApi } from "utils/headApi";
import { imgApi } from "utils/imgApi";
import classNames from "classnames";
import Radio from "@material-ui/core/Radio";
import FiberManualRecord from "@material-ui/icons/FiberManualRecord";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Check from "@material-ui/icons/Check";
import Parallax from "components/Parallax/Parallax.js";
import { makeStyles } from "@material-ui/core/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import { MdLocalShipping } from "react-icons/md";
import { RiMapPinUserFill } from "react-icons/ri";
import Slide from "@material-ui/core/Slide";
// import InputAdornment from "@material-ui/core/InputAdornment";
// import Icon from "@material-ui/core/Icon";
import { FiPhoneCall } from "react-icons/fi";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import SweetAlert from "react-bootstrap-sweetalert";

import profilePageStyle from "assets/jss/material-kit-pro-react/views/profilePageStyle.js";
import basicsCheck from "assets/jss/material-kit-pro-react/views/componentsSections/basicsStyle.js";
import popOver from "assets/jss/material-kit-pro-react/views/componentsSections/javascriptStyles.js";
import style from "assets/jss/material-kit-pro-react/components/buttonStyle.js";

import BanglesHeader from "views/BanglesPage/Section/BanglesHeader";
import BanglesHeaderLink from "views/BanglesPage/Section/BanglesHeaderLink";
import BanglesFooter from "views/BanglesPage/Section/BanglesFooter";

const useStyles = makeStyles(profilePageStyle);
const useStyle = makeStyles(basicsCheck);
const useStylPop = makeStyles(popOver);
const useStyleAlert = makeStyles(style);

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

export default function CartShippingAddress({ ...rest }) {
    const [mobile, setMobile] = React.useState("");
    const [mobileErr, setMobileErr] = React.useState("");
    const [otpNumber, setOtpNumber] = React.useState("");
    const [otpNumberErr, setOtpNumberErr] = React.useState("");
    const [otpScreen, setOtpScreen] = React.useState(false);
    const [otp, setOtp] = React.useState("");
    const [reSend, setReSend] = React.useState("");
    const [companyName, setCompanyName] = React.useState("");
    const [companyNameErr, setCompanyNameErr] = React.useState("");
    const [gstNumber, setGstNumber] = React.useState("");
    const [gstNumberErr, setGstNumberErr] = React.useState("");
    const [address, setAddress] = React.useState("");
    const [addressErr, setAddressErr] = React.useState("");
    const [address1, setAddress1] = React.useState("");
    const [address1Err, setAddress1Err] = React.useState("");
    const [address2, setAddress2] = React.useState("");
    const [address2Err, setAddress2Err] = React.useState("");
    const [address3, setAddress3] = React.useState("");
    const [address3Err, setAddress3Err] = React.useState("");
    const [zipcode, setZipcode] = React.useState("");
    const [zipcodeErr, setZipcodeErr] = React.useState("");
    const [city, setCity] = React.useState("");
    const [cityErr, setCityErr] = React.useState("");
    const [state, setState] = React.useState("");
    const [stateErr, setStateErr] = React.useState("");
    const [shipaddress, setShipaddress] = React.useState("");
    const [shipaddressErr, setShipaddressErr] = React.useState("");
    const [shipaddress1, setShipaddress1] = React.useState("");
    const [shipaddress1Err, setShipaddress1Err] = React.useState("");
    const [shipaddress2, setShipaddress2] = React.useState("");
    const [shipaddress2Err, setShipaddress2Err] = React.useState("");
    const [shipaddress3, setShipaddress3] = React.useState("");
    const [shipaddress3Err, setShipaddress3Err] = React.useState("");
    const [shipzipcode, setShipzipcode] = React.useState("");
    const [shipzipcodeErr, setShipzipcodeErr] = React.useState("");
    const [shipcity, setShipcity] = React.useState("");
    const [shipcityErr, setShipcityErr] = React.useState("");
    const [shipstate, setShipstate] = React.useState("");
    const [shipstateErr, setShipstateErr] = React.useState("");
    const [shipcompany, setShipCompany] = React.useState("");
    const [shipcompanyErr, setShipCompanyErr] = React.useState("");
    const [checkBoxValue, setCheckBoxValue] = React.useState(false);
    const [loginModal, setLoginModal] = React.useState(false);
    const [firstName, setFirstName] = React.useState("");
    const [lastName, setLastName] = React.useState("");
    const [mobileNumber, setMobileNumber] = React.useState("");
    const [whatsAppNumber, setWhatsAppNumber] = React.useState("");
    const [alternateNumber, setAlternateNumber] = React.useState("");
    const [officeNumber, setOfficeNumber] = React.useState("");
    const [countryName, setCountryName] = React.useState("");
    const [aadharNumber, setAadharNumber] = React.useState("");
    const [newAddress, setNewAddress] = React.useState(false);
    const [checkOldAddress, setCheckOldAddress] = React.useState(false);
    const [updateAdd, setUpdateAdd] = React.useState([]);
    const [shipadd, setShipadd] = React.useState("");
    const [shipadd1, setShipadd1] = React.useState("");
    const [shipadd2, setShipadd2] = React.useState("");
    const [shipadd3, setShipadd3] = React.useState("");
    const [shipzipcodes, setShipzipcodes] = React.useState("");
    const [shipcitys, setShipcitys] = React.useState("");
    const [shipstates, setShipstates] = React.useState("");
    const [shipcompanys, setShipCompanys] = React.useState("");
    const [countryNames, setCountryNames] = React.useState("");
    const [upId, setUpId] = React.useState("");
    const [firstNameU, setFirstNameU] = React.useState("");
    const [lastNameU, setLastNameU] = React.useState("");
    const [mobileNumberU, setMobileNumberU] = React.useState("");
    const [whatsAppNumberU, setWhatsAppNumberU] = React.useState("");
    const [alternateNumberU, setAlternateNumberU] = React.useState("");
    const [aadharNumberU, setAadharNumberU] = React.useState("");
    const [officeNumberU, setOfficeNumberU] = React.useState("");
    const [submitted, setSubmitted] = React.useState(false);
    const [alertMsg, alertMsgOps] = React.useState("");
    const [alertType, alertTypeOps] = React.useState("");

    // React.useEffect(() => {
    //     window.scrollTo(0, 0);
    //     document.body.scrollTop = 0;
    // });
    const classes = useStyles();
    const classe = useStyle();
    const classPop = useStylPop();
    const history = useHistory();
    const classeAlert = useStyleAlert();

    const activeSession = sessionStorage.getItem("sessionData");
    const userObj = JSON.parse(sessionStorage.getItem("sessionData"));

    const handleSendOtp = () => {
        let errorCount = 0;
        if (!mobile || mobile.length < 12) {
            errorCount++;
            setMobileErr("Please Enter 10 digit Mobile Number");
        }
        if (errorCount === 0) {
            fetch(
                headApi + `/user/sendotp?mobile=+${mobile}&type=client&webappid=1`,
                {
                    method: "PUT"
                    // headers: {
                    //   "content-type": "application/json",
                    //   accept: "application/json",
                    // },
                }
            )
                .then((response) => response.json())
                .then((response) => {
                    // console.log(response);
                    if (response.message === "Enter Registerd Mobile number") {
                        setMobileErr("Please Enter Valid Mobile Number");
                    }
                    if (response && response.error === "false") {
                        setOtpScreen({ otpScreen: true });
                        setOtp(response.message);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    };

    const handleOtp = (e) => {
        setOtpNumber(e.target.value);
        setOtpNumberErr("");
    };

    const handleLogin = () => {
        let errCount = 0;
        if (otpNumber.length !== 6) {
            errCount++;
            setOtpNumberErr("Invalid OTP");
        }

        if (errCount === 0) {
            fetch(
                headApi + `/user/login?otp=${otpNumber}&mobile=+${mobile}&type=client`,
                {
                    method: "PUT"
                    // headers: {
                    //   "content-type": "application/json",
                    //   accept: "application/json",
                    // },
                }
            )
                .then((response) => response.json())
                .then((response) => {
                    // console.log(response);
                    if (response.apiResponse.error !== "false") return false;
                    const userObj = response.user;
                    // localStorage.setItem("userObj", JSON.stringify(userObj));
                    sessionStorage.setItem("sessionData", JSON.stringify(userObj));
                    setLoginModal(false);
                    window.location.reload(false);
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    };

    const handleCall = (e) => {
        e.preventDefault();
        fetch(
            headApi + `/user/callMe?mobile=+${mobile}&webappid=1`,
            {
                method: "GET"
                // headers: {
                //   "content-type": "application/json",
                //   accept: "application/json",
                // },
            }
        )
            .then((response) => response.json())
            .then((response) => {
                if (response === "Thank You for Visiting! We will reach back to you soon.") {
                    alert("Thank You for Visiting! We will reach back to you soon.");
                }
            });
    };

    // useEffect(() => {
    //     setLoginModal(true);
    // }, []);

    React.useEffect(() => {
        axios.get(headApi + `/user/${userObj && userObj.mobile}`)
            .then((res) => {
                // console.log(res.data);
                setCompanyName(res.data.company);
                setGstNumber(res.data.gstno);
                setAddress(res.data.address);
                setAddress1(res.data.address1);
                setAddress2(res.data.address2);
                setAddress3(res.data.address3);
                setZipcode(res.data.zipcode);
                setCity(res.data.city);
                setState(res.data.state);
                // setShipaddress(res.data.shipaddress);
                // setShipaddress1(res.data.shipaddress1);
                // setShipaddress2(res.data.shipaddress2);
                // setShipaddress3(res.data.shipaddress3);
                // setShipzipcode(res.data.shipzipcode);
                // setShipcity(res.data.shipcity);
                // setShipstate(res.data.shipstate);
                // setShipCompany(res.data.company);
            })
        setLoginModal(true);
        axios.get(headApi + `/user/shipAddress/${userObj.id}`)
            .then((res) => {
                setUpdateAdd(res.data.user);
            })
    }, []);

    const handleChange = (u) => {
        setCheckOldAddress(u);
        const getAdd = updateAdd.find((f) => f.id === u.id);
        // console.log(getAdd)
        setUpId(getAdd.id);
        setShipadd(getAdd.address);
        setShipadd1(getAdd.address1);
        setShipadd2(getAdd.address2);
        setShipadd3(getAdd.address3);
        setShipzipcodes(getAdd.zipcode);
        setShipcitys(getAdd.city);
        setShipstates(getAdd.state);
        setShipCompanys(getAdd.company);
        setCountryNames(getAdd.country);
        setFirstNameU(getAdd.firstname);
        setLastNameU(getAdd.lastname);
        setMobileNumberU(getAdd.mobile);
        setWhatsAppNumberU(getAdd.whatsapp);
        setAlternateNumberU(getAdd.alternate);
        setAadharNumberU(getAdd.aadharno);
        setOfficeNumberU(getAdd.office);
    }

    const handleCheckBox = (e) => {
        if (e.target?.checked) {
            setShipCompany(companyName);
            setShipaddress(address);
            setShipaddress1(address1);
            setShipaddress2(address2);
            setShipaddress3(address3);
            setShipzipcode(zipcode);
            setShipcity(city);
            setShipstate(state);
            // setCheckBox(false);
        } else {
            setShipCompany("");
            setShipaddress("");
            setShipaddress1("");
            setShipaddress2("");
            setShipaddress3("");
            setShipzipcode("");
            setShipcity("");
            setShipstate("");
            // setCheckBox("");
        }
        setCheckBoxValue(e.target.checked);
    }

    // const handleCheckBoxAdd = (e) => {
    //     const { name, checked } = e.target;

    //     if (name) {
    //         const temp = updateAdd.map((user) => user.id == name ? { ...user, isChecked: checked } : user)
    //         console.log(temp);
    //         setUpdateAdd(temp);
    //     }

    // }

    const billUpdate = () => {
        const requestOptions = {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
            },
            body: JSON.stringify({
                mobile: userObj.mobile,
                company: companyName,
                gstno: gstNumber,
                address: address,
                address1: address1,
                address2: address2,
                address3: address3,
                zipcode: zipcode,
                city: city,
                state: state,
            }),
        };

        fetch(
            headApi + "/user/addaddress",
            requestOptions
        )
            .then((response) => response.json())
            .then((data) => {
                // console.log(data);
                if (data.message === "Address Added Successfully") {
                    setSubmitted(true);
                    alertTypeOps("success");
                    alertMsgOps("Updated Successfully");
                }
            });

    }

    const shipInsert = () => {
        let errorCount = 0;
        if (companyName === "" || !companyName) {
            errorCount++;
            setCompanyNameErr("Please Enter Company Name");
        }
        if (address === "" || !address) {
            errorCount++;
            setAddressErr("Please Enter Address");
        }
        if (address1 === "" || !address1) {
            errorCount++;
            setAddress1Err("Please Enter Address 1");
        }
        if (address2 === "" || !address2) {
            errorCount++;
            setAddress2Err("Please Enter Address 2");
        }
        if (address3 === "" || !address3) {
            errorCount++;
            setAddress3Err("Please Enter Address 3");
        }
        if (zipcode === "" || !zipcode) {
            errorCount++;
            setZipcodeErr("Please Enter Zip Code");
        }
        if (city === "" || !city) {
            errorCount++;
            setCityErr("Please Enter City");
        }
        if (state === "" || !state) {
            errorCount++;
            setStateErr("Please Enter State");
        }
        if (shipcompany === "" || !shipcompany) {
            errorCount++;
            setShipCompanyErr("Please Enter Company Name");
        }
        if (gstNumber === "" || !gstNumber) {
            errorCount++;
            setGstNumberErr("Please Enter GST Number");
        }
        if (shipaddress === "" || !shipaddress) {
            errorCount++;
            setShipaddressErr("Please Enter Shipping Address");
        }
        if (shipaddress1 === "" || !shipaddress1) {
            errorCount++;
            setShipaddress1Err("Please Enter Shipping Address1");
        }
        if (shipaddress2 === "" || !shipaddress2) {
            errorCount++;
            setShipaddress2Err("Please Enter Shipping Address2");
        }
        if (shipaddress3 === "" || !shipaddress3) {
            errorCount++;
            setShipaddress3Err("Please Enter Shipping Address3");
        }
        if (shipzipcode === "" || !shipzipcode) {
            errorCount++;
            setShipzipcodeErr("Please Enter Shipping ZipCode");
        }
        if (shipcity === "" || !shipcity) {
            errorCount++;
            setShipcityErr("Please Enter Shipping City");
        }
        if (shipstate === "" || !shipstate) {
            errorCount++;
            setShipstateErr("Please Enter Shipping State");
        }
        if (errorCount === 0) {
            const requestOptions = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
                body: JSON.stringify({
                    userid: userObj.id,
                    firstname: firstName,
                    lastname: lastName,
                    mobile: mobileNumber,
                    whatsapp: whatsAppNumber,
                    alternate: alternateNumber,
                    office: officeNumber,
                    company: shipcompany,
                    address: shipaddress,
                    address1: shipaddress1,
                    address2: shipaddress2,
                    address3: shipaddress3,
                    zipcode: shipzipcode,
                    city: shipcity,
                    state: shipstate,
                    country: countryName,
                    aadharno: aadharNumber
                }),
            };

            fetch(
                headApi + "/user/shipAddress",
                requestOptions
            )
                .then((response) => response.json())
                .then((data) => {
                    // console.log(data);
                    if (data.message === "Address Added Successfully") {
                        setSubmitted(true);
                        alertTypeOps("success");
                        alertMsgOps("Added Successfully");
                    }
                });

        }
    }

    const shipUpdate = () => {
        const requestOptions = {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
            },
            body: JSON.stringify({
                id: upId,
                company: shipcompanys,
                address: shipadd,
                address1: shipadd1,
                address2: shipadd2,
                address3: shipadd3,
                zipcode: shipzipcodes,
                city: shipcitys,
                state: shipstates,
                country: countryNames,
                firstname: firstNameU,
                lastname: lastNameU,
                mobile: mobileNumberU,
                whatsapp: whatsAppNumberU,
                alternate: alternateNumberU,
                aadharno: aadharNumberU,
                office: officeNumberU
            }),
        };

        fetch(
            headApi + "/user/shipAddress",
            requestOptions
        )
            .then((response) => response.json())
            .then((data) => {
                // console.log(data);
                if (data.message === "Address Updated Successfully") {
                    // history.push("/cart-view")
                    history.push({
                        pathname: `/cart-view`,
                        state: upId
                    })
                }
            });
    }

    const hideAlert = () => {
        setSubmitted(false);
        window.location.reload(false);
    };


    return (
        <div>
            <Helmet>
                <title>Cart Shipping Address</title>
            </Helmet>
            <BanglesHeader
                brand="Home"
                links={<BanglesHeaderLink dropdownHoverColor="info" />}
                fixed
                color="transparent"
                changeColorOnScroll={{
                    height: 100,
                    color: "info",
                }}
            />
            <Parallax
                image={require("assets/img/bg6.jpg").default}
                filter="dark"
                className={classes.parallax}
            />
            <div className={classNames(classes.main, classes.mainRaised)}>
                <div className={classes.container}>
                {submitted ? (
                        <SweetAlert
                            type={alertType}
                            style={{ display: "block", marginTop: "100px" }}
                            title={alertMsg}
                            onConfirm={() => hideAlert()}
                            confirmBtnCssClass={
                                classeAlert.button + " " + classeAlert.success
                            }
                        />
                    ) : null}
                    {!activeSession ? (
                        <GridItem xs={12} sm={6} md={6} lg={6}>
                            <Dialog
                                classes={{
                                    root: classPop.modalRoot,
                                    paper: classPop.modal + " " + classPop.modalLogin,
                                }}
                                open={loginModal}
                                TransitionComponent={Transition}
                                keepMounted
                                // onClose={() => setLoginModal(false)}
                                aria-labelledby="login-modal-slide-title"
                                aria-describedby="login-modal-slide-description"
                            >
                                <Card plain className={classPop.modalLoginCard}>
                                    <DialogTitle
                                        id="login-modal-slide-title"
                                        disableTypography
                                        className={classPop.modalHeader}
                                    >
                                        <CardHeader
                                            plain
                                            color="info"
                                            className={
                                                classPop.textCenter + " " + classPop.cardLoginHeader
                                            }
                                        >
                                            <h5 className={classPop.cardTitleWhite}>Log in</h5>
                                            <div className={classPop.socialLine}>
                                                <Button
                                                    justIcon
                                                    link
                                                    className={classPop.socialLineButton}
                                                >
                                                    <i className="fab fa-facebook-square" />
                                                </Button>
                                                <Button
                                                    justIcon
                                                    link
                                                    className={classPop.socialLineButton}
                                                >
                                                    <i className="fab fa-twitter" />
                                                </Button>
                                                <Button
                                                    justIcon
                                                    link
                                                    className={classPop.socialLineButton}
                                                >
                                                    <i className="fab fa-google-plus-g" />
                                                </Button>
                                            </div>
                                        </CardHeader>
                                    </DialogTitle>
                                    <DialogContent
                                        id="login-modal-slide-description"
                                        className={classPop.modalBody}
                                    >
                                        {!otpScreen ? (
                                            <form>
                                                <p
                                                    className={
                                                        classPop.description + " " + classPop.textCenter
                                                    }
                                                >
                                                    Welcome
                                                </p>
                                                <CardBody className={classPop.cardLoginBody}>
                                                    <PhoneInput
                                                        // style={mystyle}
                                                        inputStyle={{
                                                            width: "100%",
                                                            border: "none",
                                                            borderBottom: "1px solid #040000 ",
                                                            borderRadius: "0",
                                                        }}
                                                        country={"in"}
                                                        name="mobile"
                                                        value={mobile}
                                                        // onChange={(mobile) => handleMobileNumber(mobile)}
                                                        onChange={(mobile) => {
                                                            setMobile(
                                                                mobile.length <= 12 ? mobile : mobile
                                                            );
                                                            setMobileErr("");
                                                        }}
                                                        required={true}
                                                    />
                                                    <span style={{ color: "red" }}>{mobileErr}</span>
                                                </CardBody>
                                                <br />
                                                <div className={classes.textCenter}>
                                                    <Button
                                                        simple
                                                        color="info"
                                                        size="lg"
                                                        onClick={handleSendOtp}
                                                    >
                                                        Log in with OTP
                                                    </Button>
                                                </div>
                                                <div className={classes.textCenter}>
                                                    <Button
                                                        simple
                                                        color="info"
                                                        size="lg"
                                                        href="/insha-register"
                                                    >
                                                        Create New Account
                                                    </Button>
                                                </div>
                                            </form>
                                        ) : (
                                            <form>
                                                <p
                                                    className={
                                                        classPop.description + " " + classPop.textCenter
                                                    }
                                                >
                                                    6 digit OTP SMS sent on your mobile
                                                </p>
                                                <p
                                                    className={
                                                        classPop.description + " " + classPop.textCenter
                                                    }
                                                >
                                                    {otp}
                                                </p>
                                                <p
                                                    className={
                                                        classPop.description + " " + classPop.textCenter
                                                    }
                                                >
                                                    {reSend}
                                                </p>
                                                <CardBody className={classPop.cardLoginBody}>
                                                    <CustomInput
                                                        id="otpNumber"
                                                        formControlProps={{
                                                            fullWidth: true,
                                                        }}
                                                        inputProps={{
                                                            name: "otpNumber",
                                                            value: otpNumber,
                                                            onChange: (e) => handleOtp(e),
                                                            placeholder: "Enter OTP here",
                                                            type: "text",
                                                            // endAdornment: (
                                                            //     <InputAdornment position="end">
                                                            //         <Icon className={classes.inputIconsColor}>
                                                            //             lock_utline
                                                            //         </Icon>
                                                            //     </InputAdornment>
                                                            // ),
                                                            autoComplete: "off",
                                                        }}
                                                        required={true}
                                                    />
                                                    <p
                                                        className={
                                                            classes.description + " " + classes.textCenter
                                                        }
                                                    >
                                                        {otpNumberErr}
                                                    </p>
                                                </CardBody>
                                                <div className={classes.textCenter}>
                                                    <Button
                                                        simple
                                                        color="info"
                                                        size="lg"
                                                        onClick={handleLogin}
                                                    >
                                                        Log in
                                                    </Button>
                                                    <Button
                                                        simple
                                                        color="info"
                                                        size="lg"
                                                        onClick={handleCall}
                                                    >
                                                        <FiPhoneCall />
                                                        Call Me
                                                    </Button>
                                                </div>
                                                <p
                                                    className={
                                                        classes.description + " " + classes.textCenter
                                                    }
                                                >
                                                    {" "}
                                                    Didn't receive the OTP yet?{" "}
                                                    <span style={{ marginLeft: "10px" }}>
                                                        <a href="#" onClick={handleSendOtp}>
                                                            Resend OTP
                                                        </a>
                                                    </span>
                                                </p>
                                            </form>
                                        )}
                                    </DialogContent>
                                </Card>
                            </Dialog>
                        </GridItem>
                    ) : (
                        ""
                    )}
                    <GridContainer justify="center">
                        <GridItem xs={12} sm={12} md={6}>
                            <div className={classes.profile}>
                                <h3 className={classes.title}><RiMapPinUserFill color="#00acc1" size={35} />Billing Address</h3>
                            </div>
                        </GridItem>
                    </GridContainer>
                    <GridContainer justify="center">
                        <GridItem xs={12} sm={12} md={5}>
                            <CustomInput
                                labelText="Company Name"
                                formControlProps={{
                                    fullWidth: true,
                                    className: classes.customFormControlClasses,
                                }}
                                inputProps={{
                                    placeholder: "Company Name...",
                                    onChange: (e) => {
                                        setCompanyName(e.target.value);
                                        setCompanyNameErr("")
                                    },
                                    name: "companyName",
                                    value: companyName,
                                }}
                                id="companyName"
                                required={true}
                            />
                            <span style={{ color: "red" }}>{companyNameErr}</span>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={5}>
                            <CustomInput
                                labelText="GST Number"
                                formControlProps={{
                                    fullWidth: true,
                                    className: classes.customFormControlClasses,
                                }}
                                inputProps={{
                                    placeholder: "GST Number...",
                                    onChange: (e) => {
                                        setGstNumber(e.target.value);
                                        setGstNumberErr("")
                                    },
                                    name: "gstNumber",
                                    value: gstNumber,
                                }}
                                id="gstNumber"
                                required={true}
                            />
                            {/* <span style={{ color: "red" }}>{gstNumberErr}</span> */}
                        </GridItem>
                        <GridItem xs={12} sm={12} md={5}>
                            <CustomInput
                                labelText="Address"
                                formControlProps={{
                                    fullWidth: true,
                                    className: classes.customFormControlClasses,
                                }}
                                inputProps={{
                                    placeholder: "Address...",
                                    onChange: (e) => {
                                        setAddress(e.target.value);
                                        setAddressErr("")
                                    },
                                    name: "address",
                                    value: address,
                                }}
                                id="address"
                                required={true}
                            />
                            <span style={{ color: "red" }}>{addressErr}</span>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={5}>
                            <CustomInput
                                labelText="Address 1"
                                formControlProps={{
                                    fullWidth: true,
                                    className: classes.customFormControlClasses,
                                }}
                                inputProps={{
                                    placeholder: "Address 1...",
                                    onChange: (e) => {
                                        setAddress1(e.target.value);
                                        setAddress1Err("")
                                    },
                                    name: "address1",
                                    value: address1,
                                }}
                                id="address1"
                                required={true}
                            />
                            <span style={{ color: "red" }}>{address1Err}</span>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={5}>
                            <CustomInput
                                labelText="Address 2"
                                formControlProps={{
                                    fullWidth: true,
                                    className: classes.customFormControlClasses,
                                }}
                                inputProps={{
                                    placeholder: "Address 2...",
                                    onChange: (e) => {
                                        setAddress2(e.target.value);
                                        setAddress2Err("")
                                    },
                                    name: "address2",
                                    value: address2,
                                }}
                                id="address2"
                                required={true}
                            />
                            <span style={{ color: "red" }}>{address2Err}</span>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={5}>
                            <CustomInput
                                labelText="Address 3"
                                formControlProps={{
                                    fullWidth: true,
                                    className: classes.customFormControlClasses,
                                }}
                                inputProps={{
                                    placeholder: "Address 3...",
                                    onChange: (e) => {
                                        setAddress3(e.target.value);
                                        setAddress3Err("")
                                    },
                                    name: "address3",
                                    value: address3,
                                }}
                                id="address3"
                                required={true}
                            />
                            <span style={{ color: "red" }}>{address3Err}</span>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={5}>
                            <CustomInput
                                labelText="Zip Code"
                                formControlProps={{
                                    fullWidth: true,
                                    className: classes.customFormControlClasses,
                                }}
                                inputProps={{
                                    placeholder: "Zip Code...",
                                    onChange: (e) => {
                                        setZipcode(e.target.value);
                                        setZipcodeErr("")
                                    },
                                    name: "zipcode",
                                    value: zipcode,
                                }}
                                id="zipCode"
                                required={true}
                            />
                            <span style={{ color: "red" }}>{zipcodeErr}</span>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={5}>
                            <CustomInput
                                labelText="City"
                                formControlProps={{
                                    fullWidth: true,
                                    className: classes.customFormControlClasses,
                                }}
                                inputProps={{
                                    placeholder: "City...",
                                    onChange: (e) => {
                                        setCity(e.target.value);
                                        setCityErr("")
                                    },
                                    name: "city",
                                    value: city,
                                }}
                                id="city"
                                required={true}
                            />
                            <span style={{ color: "red" }}>{cityErr}</span>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={5}>
                            <CustomInput
                                labelText="State"
                                formControlProps={{
                                    fullWidth: true,
                                    className: classes.customFormControlClasses,
                                }}
                                inputProps={{
                                    placeholder: "State...",
                                    onChange: (e) => {
                                        setState(e.target.value);
                                        setStateErr("")
                                    },
                                    name: "state",
                                    value: state,
                                }}
                                id="state"
                                required={true}
                            />
                            <span style={{ color: "red" }}>{stateErr}</span>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={5}>

                        </GridItem>
                    </GridContainer>
                    <br />
                    <GridContainer justify="center">
                        <Button color="info" onClick={billUpdate}>Update</Button>
                    </GridContainer>
                    <br />

                </div>
            </div>
            <div className={classNames(classes.main, classes.mainRaised)} style={{ marginTop: "3%" }}>
                <div className={classes.container}>
                {submitted ? (
                        <SweetAlert
                            type={alertType}
                            style={{ display: "block", marginTop: "100px" }}
                            title={alertMsg}
                            onConfirm={() => hideAlert()}
                            confirmBtnCssClass={
                                classeAlert.button + " " + classeAlert.success
                            }
                        />
                    ) : null}
                    <GridContainer justify="center">
                        <GridItem xs={12} sm={12} md={6}>
                            <div className={classes.profile}>
                                <h3 className={classes.title}><MdLocalShipping color="#00acc1" size={35} /> Shipping Address</h3>
                            </div>
                        </GridItem>
                    </GridContainer>
                    {newAddress === true ?
                        <GridContainer>
                            <GridItem md={12} sm={12} xs={12}>
                                <Button color="info" onClick={() => setNewAddress(false)}>Add New Address</Button>
                            </GridItem>
                        </GridContainer>
                        :
                        <GridContainer>
                            <GridItem md={12} sm={12} xs={12}>
                                <Button color="info" onClick={() => setNewAddress(true)}>Add New Address</Button>
                            </GridItem>
                        </GridContainer>}
                    <br />
                    {newAddress === true ? <>
                        <GridContainer justify="center">
                            <GridItem xs={12} sm={12} md={10}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={checkBoxValue || false}
                                            onChange={(e) => handleCheckBox(e)}
                                            tabIndex={-1}
                                            //   onClick={() => handleToggle(21)}
                                            checkedIcon={<Check className={classe.checkedIcon} />}
                                            icon={<Check className={classe.uncheckedIcon} />}
                                            classes={{
                                                checked: classe.checked,
                                                root: classe.checkRoot,
                                            }}
                                        />
                                    }
                                    classes={{ label: classe.label, root: classe.labelRoot }}
                                    label="Same as Address"
                                />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={5}>
                                <CustomInput
                                    labelText="First Name"
                                    formControlProps={{
                                        fullWidth: true,
                                        className: classes.customFormControlClasses,
                                    }}
                                    inputProps={{
                                        placeholder: "First Name...",
                                        onChange: (e) => {
                                            setFirstName(e.target.value);
                                            // setFirstNameErr("")
                                        },
                                        name: "firstName",
                                        value: firstName,
                                    }}
                                    id="firstName"
                                // required={true}
                                />
                                {/* <span style={{ color: "red" }}>{firstNameErr}</span> */}
                            </GridItem>
                            <GridItem xs={12} sm={12} md={5}>
                                <CustomInput
                                    labelText="Last Name"
                                    formControlProps={{
                                        fullWidth: true,
                                        className: classes.customFormControlClasses,
                                    }}
                                    inputProps={{
                                        placeholder: "Last Name...",
                                        onChange: (e) => {
                                            setLastName(e.target.value);
                                            // setLastNameErr("")
                                        },
                                        name: "lastName",
                                        value: lastName,
                                    }}
                                    id="lastName"
                                // required={true}
                                />
                                {/* <span style={{ color: "red" }}>{lastNameErr}</span> */}
                            </GridItem>
                            <GridItem xs={12} sm={12} md={5}>
                                <CustomInput
                                    labelText="Mobile Number"
                                    formControlProps={{
                                        fullWidth: true,
                                        className: classes.customFormControlClasses,
                                    }}
                                    inputProps={{
                                        placeholder: "Mobile Number...",
                                        onChange: (e) => {
                                            setMobileNumber(e.target.value);
                                            // setMobileNumberErr("")
                                        },
                                        name: "mobileNumber",
                                        value: mobileNumber,
                                    }}
                                    id="mobileNumber"
                                // required={true}
                                />
                                {/* <span style={{ color: "red" }}>{mobileNumberErr}</span> */}
                            </GridItem>
                            <GridItem xs={12} sm={12} md={5}>
                                <CustomInput
                                    labelText="WhatsApp Number"
                                    formControlProps={{
                                        fullWidth: true,
                                        className: classes.customFormControlClasses,
                                    }}
                                    inputProps={{
                                        placeholder: "WhatsApp Number...",
                                        onChange: (e) => {
                                            setWhatsAppNumber(e.target.value);
                                            // setWhatsAppNumberErr("")
                                        },
                                        name: "whatsAppNumber",
                                        value: whatsAppNumber,
                                    }}
                                    id="whatsAppNumber"
                                // required={true}
                                />
                                {/* <span style={{ color: "red" }}>{whatsAppNumberErr}</span> */}
                            </GridItem>
                            <GridItem xs={12} sm={12} md={5}>
                                <CustomInput
                                    labelText="Alternate Number"
                                    formControlProps={{
                                        fullWidth: true,
                                        className: classes.customFormControlClasses,
                                    }}
                                    inputProps={{
                                        placeholder: "Alternate Number...",
                                        onChange: (e) => {
                                            setAlternateNumber(e.target.value);
                                            // setAlternateNumberErr("")
                                        },
                                        name: "alternateNumber",
                                        value: alternateNumber,
                                    }}
                                    id="alternateNumber"
                                // required={true}
                                />
                                {/* <span style={{ color: "red" }}>{alternateNumberErr}</span> */}
                            </GridItem>
                            <GridItem xs={12} sm={12} md={5}>
                                <CustomInput
                                    labelText="Office Number"
                                    formControlProps={{
                                        fullWidth: true,
                                        className: classes.customFormControlClasses,
                                    }}
                                    inputProps={{
                                        placeholder: "Office Number...",
                                        onChange: (e) => {
                                            setOfficeNumber(e.target.value);
                                            // setOffuceNumberErr("")
                                        },
                                        name: "officeNumber",
                                        value: officeNumber,
                                    }}
                                    id="officeNumber"
                                // required={true}
                                />
                                {/* <span style={{ color: "red" }}>{officeNumberErr}</span> */}
                            </GridItem>
                            <GridItem xs={12} sm={12} md={5}>
                                <CustomInput
                                    labelText="Company Name"
                                    formControlProps={{
                                        fullWidth: true,
                                        className: classes.customFormControlClasses,
                                    }}
                                    inputProps={{
                                        placeholder: "Company Name...",
                                        name: "shipCompany",
                                        value: shipcompany,
                                        onChange: (e) => {
                                            setShipCompany(e.target.value);
                                            setShipCompanyErr("")
                                            if (companyName === shipcompany) {
                                                setCheckBoxValue(true)
                                            } else {
                                                setCheckBoxValue(false)
                                            }
                                        },
                                    }}
                                    id="companyName"
                                    required={true}
                                />
                                <span style={{ color: "red" }}>{shipcompanyErr}</span>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={5}>
                                <CustomInput
                                    labelText="Aadhar Number"
                                    formControlProps={{
                                        fullWidth: true,
                                        className: classes.customFormControlClasses,
                                    }}
                                    inputProps={{
                                        placeholder: "Aadhar Number...",
                                        onChange: (e) => {
                                            setAadharNumber(e.target.value);
                                            // setAadharNumberErr("")
                                        },
                                        name: "aadharNumber",
                                        value: aadharNumber,
                                    }}
                                    id="aadharNumber"
                                // required={true}
                                />
                                {/* <span style={{ color: "red" }}>{aadharNumberErr}</span> */}
                            </GridItem>
                            <GridItem xs={12} sm={12} md={5}>
                                <CustomInput
                                    labelText="Shipping Address"
                                    formControlProps={{
                                        fullWidth: true,
                                        className: classes.customFormControlClasses,
                                    }}
                                    inputProps={{
                                        placeholder: "Shipping Address...",
                                        onChange: (e) => {
                                            setShipaddress(e.target.value)
                                            setShipaddressErr("")
                                        },
                                        name: "shipaddress",
                                        value: shipaddress,
                                    }}
                                    id="shipAddress"
                                    required={true}
                                />
                                <span style={{ color: "red" }}>{shipaddressErr}</span>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={5}>
                                <CustomInput
                                    labelText="Shipping Address 1"
                                    formControlProps={{
                                        fullWidth: true,
                                        className: classes.customFormControlClasses,
                                    }}
                                    inputProps={{
                                        placeholder: "Shipping Address 1...",
                                        onChange: (e) => {
                                            setShipaddress1(e.target.value)
                                            setShipaddress1Err("")
                                        },
                                        name: "shipaddress1",
                                        value: shipaddress1,
                                    }}
                                    id="shipAddress1"
                                    required={true}
                                />
                                <span style={{ color: "red" }}>{shipaddress1Err}</span>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={5}>
                                <CustomInput
                                    labelText="Shipping Address 2"
                                    formControlProps={{
                                        fullWidth: true,
                                        className: classes.customFormControlClasses,
                                    }}
                                    inputProps={{
                                        placeholder: "Shipping Address 2...",
                                        onChange: (e) => {
                                            setShipaddress2(e.target.value);
                                            setShipaddress2Err("")
                                        },
                                        name: "shipaddress2",
                                        value: shipaddress2,
                                    }}
                                    id="shipAddress2"
                                    required={true}
                                />
                                <span style={{ color: "red" }}>{shipaddress2Err}</span>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={5}>
                                <CustomInput
                                    labelText="Shipping Address 3"
                                    formControlProps={{
                                        fullWidth: true,
                                        className: classes.customFormControlClasses,
                                    }}
                                    inputProps={{
                                        placeholder: "Shipping Address 3...",
                                        onChange: (e) => {
                                            setShipaddress3(e.target.value);
                                            setShipaddress3Err("")
                                        },
                                        name: "shipaddress3",
                                        value: shipaddress3,
                                    }}
                                    id="shipAddress3"
                                    required={true}
                                />
                                <span style={{ color: "red" }}>{shipaddress3Err}</span>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={5}>
                                <CustomInput
                                    labelText="Shipping Zip Code"
                                    formControlProps={{
                                        fullWidth: true,
                                        className: classes.customFormControlClasses,
                                    }}
                                    inputProps={{
                                        placeholder: "Shipping Zip Code...",
                                        onChange: (e) => {
                                            setShipzipcode(e.target.value);
                                            setShipzipcodeErr("")
                                        },
                                        name: "shipzipcode",
                                        value: shipzipcode,
                                    }}
                                    id="shipZipCode"
                                    required={true}
                                />
                                <span style={{ color: "red" }}>{shipzipcodeErr}</span>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={5}>
                                <CustomInput
                                    labelText="Shipping City"
                                    formControlProps={{
                                        fullWidth: true,
                                        className: classes.customFormControlClasses,
                                    }}
                                    inputProps={{
                                        placeholder: "Shpping City...",
                                        onChange: (e) => {
                                            setShipcity(e.target.value);
                                            setShipcityErr("")
                                        },
                                        name: "shipcity",
                                        value: shipcity,
                                    }}
                                    id="shipCity"
                                    required={true}
                                />
                                <span style={{ color: "red" }}>{shipcityErr}</span>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={5}>
                                <CustomInput
                                    labelText="Shipping State"
                                    formControlProps={{
                                        fullWidth: true,
                                        className: classes.customFormControlClasses,
                                    }}
                                    inputProps={{
                                        placeholder: "Shpping State...",
                                        onChange: (e) => {
                                            setShipstate(e.target.value);
                                            setShipstateErr("")
                                        },
                                        name: "shipstate",
                                        value: shipstate,
                                    }}
                                    id="shipState"
                                    required={true}
                                />
                                <span style={{ color: "red" }}>{shipstateErr}</span>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={5}>
                                <CustomInput
                                    labelText="Country Name"
                                    formControlProps={{
                                        fullWidth: true,
                                        className: classes.customFormControlClasses,
                                    }}
                                    inputProps={{
                                        placeholder: "Country Name...",
                                        onChange: (e) => {
                                            setCountryName(e.target.value);
                                            // setCountryNameErr("")
                                        },
                                        name: "countryName",
                                        value: countryName,
                                    }}
                                    id="countryName"
                                // required={true}
                                />
                                {/* <span style={{ color: "red" }}>{countryNameErr}</span> */}
                            </GridItem>
                        </GridContainer>
                        <br />
                        <GridContainer justify="center">
                            <Button color="info" onClick={shipInsert}>Save</Button>
                        </GridContainer>
                        <br />
                    </>
                        : ""}
                    <br />
                </div>
            </div>
            {newAddress === true ? "" :
                <div className={classes.container}>
                    <GridContainer>
                        {updateAdd && updateAdd.map((u) => (
                            <GridItem md={4} key={u.id}>
                                <Card>
                                    <CardBody>
                                        <FormControlLabel
                                            key={u.id}
                                            control={
                                                <Radio
                                                    checked={checkOldAddress && checkOldAddress.id ? checkOldAddress?.id === u?.id : ""}
                                                    onChange={() => handleChange(u)}
                                                    // onChange={(e) => {
                                                    //     setCheckOldAddress(u);
                                                    // }}
                                                    value={u.id}
                                                    name="radio button enabled"
                                                    aria-label="A"
                                                    icon={
                                                        <FiberManualRecord className={classe.radioUnchecked} />
                                                    }
                                                    checkedIcon={
                                                        <FiberManualRecord className={classe.radioChecked} />
                                                    }
                                                    classes={{
                                                        checked: classe.radio,
                                                        root: classe.radioRoot,
                                                    }}
                                                />
                                            }
                                            classes={{
                                                label: classe.label,
                                                root: classe.labelRoot,
                                            }}
                                            label={<h6 className={classes.description}><span className={classes.title}>Shipping Address</span> <br /> {u.address + "," + u.address1 + "," + u.address2 + "," + u.address3 + "," + u.zipcode + "," + u.city + "," + u.state + "," + u.country}</h6>}
                                        />
                                    </CardBody>
                                </Card>
                            </GridItem>
                        ))}
                    </GridContainer>
                </div>
            }
            <div className={classNames(classes.main, classes.mainRaised)} style={{ marginTop: "1%" }}>
                <div className={classes.container}>
                    {!checkOldAddress || newAddress === true ? "" : <>
                        <br />
                        <GridContainer justify="center">
                            <GridItem xs={12} sm={12} md={5}>
                                <CustomInput
                                    labelText="Company Name"
                                    formControlProps={{
                                        fullWidth: true,
                                        className: classes.customFormControlClasses,
                                    }}
                                    inputProps={{
                                        placeholder: "Company Name...",
                                        name: "shipcompanys",
                                        value: shipcompanys,
                                        onChange: (e) => {
                                            setShipCompanys(e.target.value);
                                            // setShipCompanyErr("")
                                            // if (companyName === shipcompany) {
                                            //     setCheckBoxValue(true)
                                            // } else {
                                            //     setCheckBoxValue(false)
                                            // }
                                        },
                                    }}
                                    id="shipcompanys"
                                // required={true}
                                />
                                {/* <span style={{ color: "red" }}>{shipcompanyErr}</span> */}
                            </GridItem>
                            <GridItem xs={12} sm={12} md={5}>
                                <CustomInput
                                    labelText="First Name"
                                    formControlProps={{
                                        fullWidth: true,
                                        className: classes.customFormControlClasses,
                                    }}
                                    inputProps={{
                                        placeholder: "First Name...",
                                        onChange: (e) => {
                                            setFirstNameU(e.target.value);
                                            // setFirstNameErr("")
                                        },
                                        name: "firstNameU",
                                        value: firstNameU,
                                    }}
                                    id="firstNameU"
                                // required={true}
                                />
                                {/* <span style={{ color: "red" }}>{firstNameErr}</span> */}
                            </GridItem>
                            <GridItem xs={12} sm={12} md={5}>
                                <CustomInput
                                    labelText="Last Name"
                                    formControlProps={{
                                        fullWidth: true,
                                        className: classes.customFormControlClasses,
                                    }}
                                    inputProps={{
                                        placeholder: "Last Name...",
                                        onChange: (e) => {
                                            setLastNameU(e.target.value);
                                            // setLastNameErr("")
                                        },
                                        name: "lastNameU",
                                        value: lastNameU,
                                    }}
                                    id="lastNameU"
                                // required={true}
                                />
                                {/* <span style={{ color: "red" }}>{lastNameErr}</span> */}
                            </GridItem>
                            <GridItem xs={12} sm={12} md={5}>
                                <CustomInput
                                    labelText="Mobile Number"
                                    formControlProps={{
                                        fullWidth: true,
                                        className: classes.customFormControlClasses,
                                    }}
                                    inputProps={{
                                        placeholder: "Mobile Number...",
                                        onChange: (e) => {
                                            setMobileNumberU(e.target.value);
                                            // setMobileNumberErr("")
                                        },
                                        name: "mobileNumberU",
                                        value: mobileNumberU,
                                    }}
                                    id="mobileNumberU"
                                // required={true}
                                />
                                {/* <span style={{ color: "red" }}>{mobileNumberErr}</span> */}
                            </GridItem>
                            <GridItem xs={12} sm={12} md={5}>
                                <CustomInput
                                    labelText="WhatsApp Number"
                                    formControlProps={{
                                        fullWidth: true,
                                        className: classes.customFormControlClasses,
                                    }}
                                    inputProps={{
                                        placeholder: "WhatsApp Number...",
                                        onChange: (e) => {
                                            setWhatsAppNumberU(e.target.value);
                                            // setWhatsAppNumberErr("")
                                        },
                                        name: "whatsAppNumberU",
                                        value: whatsAppNumberU,
                                    }}
                                    id="whatsAppNumberU"
                                // required={true}
                                />
                                {/* <span style={{ color: "red" }}>{whatsAppNumberErr}</span> */}
                            </GridItem>
                            <GridItem xs={12} sm={12} md={5}>
                                <CustomInput
                                    labelText="Alternate Number"
                                    formControlProps={{
                                        fullWidth: true,
                                        className: classes.customFormControlClasses,
                                    }}
                                    inputProps={{
                                        placeholder: "Alternate Number...",
                                        onChange: (e) => {
                                            setAlternateNumberU(e.target.value);
                                            // setAlternateNumberErr("")
                                        },
                                        name: "alternateNumberU",
                                        value: alternateNumberU,
                                    }}
                                    id="alternateNumberU"
                                // required={true}
                                />
                                {/* <span style={{ color: "red" }}>{alternateNumberErr}</span> */}
                            </GridItem>
                            <GridItem xs={12} sm={12} md={5}>
                                <CustomInput
                                    labelText="Office Number"
                                    formControlProps={{
                                        fullWidth: true,
                                        className: classes.customFormControlClasses,
                                    }}
                                    inputProps={{
                                        placeholder: "Office Number...",
                                        onChange: (e) => {
                                            setOfficeNumberU(e.target.value);
                                            // setOffuceNumberErr("")
                                        },
                                        name: "officeNumberU",
                                        value: officeNumberU,
                                    }}
                                    id="officeNumberU"
                                // required={true}
                                />
                                {/* <span style={{ color: "red" }}>{officeNumberErr}</span> */}
                            </GridItem>
                            <GridItem xs={12} sm={12} md={5}>
                                <CustomInput
                                    labelText="Aadhar Number"
                                    formControlProps={{
                                        fullWidth: true,
                                        className: classes.customFormControlClasses,
                                    }}
                                    inputProps={{
                                        placeholder: "Aadhar Number...",
                                        onChange: (e) => {
                                            setAadharNumberU(e.target.value);
                                            // setAadharNumberErr("")
                                        },
                                        name: "aadharNumberU",
                                        value: aadharNumberU,
                                    }}
                                    id="aadharNumberU"
                                // required={true}
                                />
                                {/* <span style={{ color: "red" }}>{aadharNumberErr}</span> */}
                            </GridItem>
                            <GridItem xs={12} sm={12} md={5}>
                                <CustomInput
                                    labelText="Shipping Address"
                                    formControlProps={{
                                        fullWidth: true,
                                        className: classes.customFormControlClasses,
                                    }}
                                    inputProps={{
                                        placeholder: "Shipping Address...",
                                        onChange: (e) => {
                                            setShipadd(e.target.value)
                                            // setShipaddressErr("")
                                        },
                                        name: "shipadd",
                                        value: shipadd,
                                    }}
                                    id="shipAdd"
                                // required={true}
                                />
                                {/* <span style={{ color: "red" }}>{shipaddressErr}</span> */}
                            </GridItem>
                            <GridItem xs={12} sm={12} md={5}>
                                <CustomInput
                                    labelText="Shipping Address 1"
                                    formControlProps={{
                                        fullWidth: true,
                                        className: classes.customFormControlClasses,
                                    }}
                                    inputProps={{
                                        placeholder: "Shipping Address 1...",
                                        onChange: (e) => {
                                            setShipadd1(e.target.value)
                                            // setShipaddress1Err("")
                                        },
                                        name: "shipadd1",
                                        value: shipadd1,
                                    }}
                                    id="shipAdd1"
                                // required={true}
                                />
                                {/* <span style={{ color: "red" }}>{shipaddress1Err}</span> */}
                            </GridItem>
                            <GridItem xs={12} sm={12} md={5}>
                                <CustomInput
                                    labelText="Shipping Address 2"
                                    formControlProps={{
                                        fullWidth: true,
                                        className: classes.customFormControlClasses,
                                    }}
                                    inputProps={{
                                        placeholder: "Shipping Address 2...",
                                        onChange: (e) => {
                                            setShipadd2(e.target.value);
                                            // setShipaddress2Err("")
                                        },
                                        name: "shipadd2",
                                        value: shipadd2,
                                    }}
                                    id="shipAdd2"
                                // required={true}
                                />
                                {/* <span style={{ color: "red" }}>{shipaddress2Err}</span> */}
                            </GridItem>
                            <GridItem xs={12} sm={12} md={5}>
                                <CustomInput
                                    labelText="Shipping Address 3"
                                    formControlProps={{
                                        fullWidth: true,
                                        className: classes.customFormControlClasses,
                                    }}
                                    inputProps={{
                                        placeholder: "Shipping Address 3...",
                                        onChange: (e) => {
                                            setShipadd3(e.target.value);
                                            // setShipaddress3Err("")
                                        },
                                        name: "shipadd3",
                                        value: shipadd3,
                                    }}
                                    id="shipAdd3"
                                // required={true}
                                />
                                {/* <span style={{ color: "red" }}>{shipaddress3Err}</span> */}
                            </GridItem>
                            <GridItem xs={12} sm={12} md={5}>
                                <CustomInput
                                    labelText="Shipping Zip Code"
                                    formControlProps={{
                                        fullWidth: true,
                                        className: classes.customFormControlClasses,
                                    }}
                                    inputProps={{
                                        placeholder: "Shipping Zip Code...",
                                        onChange: (e) => {
                                            setShipzipcodes(e.target.value);
                                            // setShipzipcodeErr("")
                                        },
                                        name: "shipzipcodes",
                                        value: shipzipcodes,
                                    }}
                                    id="shipZipCodes"
                                // required={true}
                                />
                                {/* <span style={{ color: "red" }}>{shipzipcodeErr}</span> */}
                            </GridItem>
                            <GridItem xs={12} sm={12} md={5}>
                                <CustomInput
                                    labelText="Shipping City"
                                    formControlProps={{
                                        fullWidth: true,
                                        className: classes.customFormControlClasses,
                                    }}
                                    inputProps={{
                                        placeholder: "Shpping City...",
                                        onChange: (e) => {
                                            setShipcitys(e.target.value);
                                            // setShipcityErr("")
                                        },
                                        name: "shipcitys",
                                        value: shipcitys,
                                    }}
                                    id="shipCitys"
                                // required={true}
                                />
                                {/* <span style={{ color: "red" }}>{shipcityErr}</span> */}
                            </GridItem>
                            <GridItem xs={12} sm={12} md={5}>
                                <CustomInput
                                    labelText="Shipping State"
                                    formControlProps={{
                                        fullWidth: true,
                                        className: classes.customFormControlClasses,
                                    }}
                                    inputProps={{
                                        placeholder: "Shpping State...",
                                        onChange: (e) => {
                                            setShipstates(e.target.value);
                                            // setShipstateErr("")
                                        },
                                        name: "shipstates",
                                        value: shipstates,
                                    }}
                                    id="shipStates"
                                // required={true}
                                />
                                {/* <span style={{ color: "red" }}>{shipstateErr}</span> */}
                            </GridItem>
                            <GridItem xs={12} sm={12} md={5}>
                                <CustomInput
                                    labelText="Country Name"
                                    formControlProps={{
                                        fullWidth: true,
                                        className: classes.customFormControlClasses,
                                    }}
                                    inputProps={{
                                        placeholder: "Country Name...",
                                        onChange: (e) => {
                                            setCountryNames(e.target.value);
                                            // setCountryNameErr("")
                                        },
                                        name: "countryNames",
                                        value: countryNames,
                                    }}
                                    id="countryNames"
                                // required={true}
                                />
                                {/* <span style={{ color: "red" }}>{countryNameErr}</span> */}
                            </GridItem>
                            <GridItem xs={12} sm={12} md={5}>
                            </GridItem>
                        </GridContainer>
                        <br />
                        <GridContainer justify="center">
                            <Button color="info" onClick={shipUpdate}>Save</Button>
                        </GridContainer>
                        <br />
                    </>}
                </div>
            </div>
            <br />
            <BanglesFooter />
        </div>
    );
}
